import scalesProvider from '../../provider/scales.provider';
import React, { useState } from 'react';
import { Typography, Button as MUIButton, Dialog, DialogTitle, DialogContent, DialogActions, Divider, IconButton, Slide } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNotify } from 'react-admin';


const useStyles = makeStyles((theme) => ({
    titleRoot: {
        paddingRight: theme.spacing(6),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
}));

export const ScaleNote = (props) => {
    const [editDialog] = useState(false);
    const classes = useStyles();
    const notify = useNotify();
    const { openScaleNote, handleDialogScaleNote } = props;
    const rawData = props?.data || {};
    const register = props?.register ?? (Array.isArray(rawData?.scaleResponses) ? rawData : rawData?.register);
    const [notes, setNotes] = useState(register?.scaleNotes ?? '');
    


// ScaleNote.js - Función sendUpdateNote modificada
const sendUpdateNote = async () => {
    if (!register?.id) return;
    const dto = {
        id: register.id,
        scaleNotes: notes,
    };
    try {
        await scalesProvider.updatedScaleNotes(null, dto);
        notify('Nota guardada', { type: 'info' });
        
        // MODIFICACIÓN MÍNIMA: Si existe la función de éxito, la llamamos
        if (props.onSaveSuccess) {
            await props.onSaveSuccess();
        }
        
        handleDialogScaleNote(false);
    } catch (err) {
        console.error('updatedScaleNotes error', err);
        handleDialogScaleNote(false);
    }
};

    return (
        <>
            <Dialog
                open={openScaleNote}
                onClose={() => (!editDialog && handleDialogScaleNote(false))}
                aria-labelledby="confirm-start-dialog-title"
                fullWidth
                maxWidth="md"
                disableBackdropClick={editDialog}
                disableEscapeKeyDown={editDialog}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'up' }}
            >
                <DialogTitle id="confirm-start-dialog-title" disableTypography className={classes.titleRoot}>
                    <Typography variant="h6">Notas</Typography>
                    <IconButton
                        aria-label="Cerrar"
                        onClick={() => (!editDialog && handleDialogScaleNote(false))}
                        className={classes.closeButton}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <ReactQuill theme="snow" value={notes} onChange={setNotes} />
                </DialogContent>
                <DialogActions>
                    <MUIButton onClick={() => handleDialogScaleNote(false)} disabled={editDialog}>Cancelar</MUIButton>
                    <MUIButton
                        color="primary"
                        variant="contained"
                        onClick={sendUpdateNote}
                        disabled={editDialog}
                        autoFocus
                    >
                        Guardar                        
                    </MUIButton>
                </DialogActions>
            </Dialog>
        </>
    );
}
